export default "__VITE_ASSET__xUfAOc8vsLn5godiQWqFgA__";